import React, { useState, useEffect } from "react";
import { useAppContext } from "../../../contexts/AppContext";
import Dialog from "carbon-react/lib/components/dialog";
import Heading from "carbon-react/lib/components/heading";
import Content from "carbon-react/lib/components/content";
import TextArea from "carbon-react/lib/__experimental__/components/textarea";
import ErrorMessage from "../../messages/ErrorMessage";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import ConfirmDialog from "../../common/confirmDialog/ConfirmDialog";
import { useUserApi } from "../../../services/UserApi";
import StepTitle from "../../common/stepTitle/StepTitle";

const initialState = {
  agentComments: "",
  validAgentComments: true,
  email: "",
  validEmail: true,
};

const BypassMfaDialog = ({ open, user, onClose }) => {
  const { bypassMfa } = useUserApi();
  const [errorMsg, setErrorMsg] = useState("");
  const [showError, setShowError] = useState(false);
  const [agentComments, setAgentComments] = useState(
    initialState.agentComments
  );
  const [validAgentComments, setValidAgentComments] = useState(
    initialState.validAgentComments
  );

  const [busy, setBusy] = useState(false);
  const { toastSuccess } = useAppContext();
  const [
    confirmBypassMfaOpen,
    setConfirmBypassMfaOpen,
  ] = useState(false);

  const showDialogError = (msg) => {
    setErrorMsg(msg);
    setShowError(true);
  };

  const clearDialogError = () => {
    setErrorMsg("");
    setShowError(false);
  };

  const validateAgentComments = () => {
    let valid = true;

    if (agentComments.length === 0) {
      valid = false;
    }

    setValidAgentComments(valid);
    return valid;
  };

  const validateInputs = () => {
    let valid = true;
    if (!validateAgentComments()) valid = false;
    return valid;
  };

  const onDialogBypassMfa = () => {
    if (!validateInputs()) return;
    setConfirmBypassMfaOpen(true);
  };

  const onConfirmBypassMfaClose = () => {
    setConfirmBypassMfaOpen(false);
  };

  const onConfirmBypassMfaContinue = async () => {
    setConfirmBypassMfaOpen(false);
    await performBypassMfa();
  };

  const performBypassMfa = async () => {
    if (busy) return;

    try {
      clearDialogError();
      setBusy(true);
      var apiResult = await bypassMfa(
        user.userId,
        agentComments,
        !user.mfaBypassEnabled
      );

      if (!apiResult?.success)
        throw new Error(
          apiResult?.error?.description ||
            "The bypass Mfa failed"
        );

      toastSuccess(
        !user.mfaBypassEnabled? `User MFA verification successfully bypassed - '${user.email}'`
        : `User MFA verification successfully disabled - '${user.email}'`        
      );
      onClose();
      resetDialogState();
    } catch (error) {
      showDialogError(error.toString());
      setConfirmBypassMfaOpen(false);      
    }
    setBusy(false);
    setErrorMsg("");
  };

  const resetDialogState = () => {
    clearDialogError();
    setConfirmBypassMfaOpen(false);
    setAgentComments(initialState.agentComments);
    setValidAgentComments(initialState.validAgentComments);
  };

  const onDialogCancel = () => {
    resetDialogState();
    onClose();
  };

  const agentCommentsValidationAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please indicate why this action is being performed.",
  };

  const confirmBypassMfa = (
    <ConfirmDialog
      open={confirmBypassMfaOpen}
      prompt=
      {user && !user.mfaBypassEnabled? "Are you certain you want to Enable bypass Mfa verification for this user?"
       : "Are you certain you want to Disable bypass Mfa verification for this user?"}
      confirmBtnLabel="Confirm"
      onConfirm={onConfirmBypassMfaContinue}
      onCancel={onConfirmBypassMfaClose}
    />
  );

  const agentCommentsInput = (
    <Content title="Comments">
      <TextArea
        name="bypass-mfa-verification-agent-comments"
        disabled={busy}
        value={agentComments}
        characterLimit={"250"}
        enforceCharacterLimit={true}
        placeholder={"Please indicate why this action is being performed."}
        onChange={(e) => {
          setValidAgentComments(true);
          setAgentComments(e.target.value);
        }}
        onBlur={validateAgentComments}
        {...(!validAgentComments ? agentCommentsValidationAttributes : {})}
      />
    </Content>
  );

  const dialogButtons = (
    
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnLabel={user && !user.mfaBypassEnabled?"Bypass Mfa"
      : "Disable Mfa"}
      onConfirm={onDialogBypassMfa}
      onCancel={onDialogCancel}
    />
  );

  const errorMessage = (
    <>
      {showError !== true ? null : (
        <ErrorMessage
          message={
            errorMsg && errorMsg.length > 0 ? errorMsg : "The operation failed!"
          }
        />
      )}
    </>
  );

  return (
    <>
      <Dialog
        open={open}
        showCloseIcon={true}
        onClose={onDialogCancel}
        onCancel={onDialogCancel}
      >
        <Heading title={user && !user.mfaBypassEnabled?"Bypass Mfa": "Disable Bypass Mfa"} />
        <StepTitle title={user && !user.mfaBypassEnabled?"Bypassing MFA allows the user to log in without attempting MFA."
        :"Disabling MFA will force user to attempt MFA when they log in." }/>
        {agentCommentsInput}
        {dialogButtons}
        {errorMessage}
      </Dialog>
      {confirmBypassMfa}
      
    </>
  );
};

export default BypassMfaDialog;
